/*
 * NOTICE:  All information contained herein is, and remains the property of Power Settlements Consulting and Software, LLC. 
 * The intellectual and technical concepts contained herein are proprietary to Power Settlements Consulting and Software, LLC 
 * and are protected by trade secret or copyright law. Dissemination or reproduction of this material, in whole or in part, 
 * is strictly forbidden without the prior written permission of Power Settlements Consulting and Software, LLC.
 * Copyright (c) Power Settlements Consulting and Software, LLC. All rights reserved.
*/

import { CISO_CMRI_API } from '@/api';
import { getMomentDateStringFromRangeArray } from '@/utils/dateUtil';
import moment from 'moment';

const state = {
  tableData: [],
};

const actions = {
  async fetchContractUsage({ commit }, parameters) {
    const { startDate, endDate } = getMomentDateStringFromRangeArray(parameters.tradeDateRangeSelected);
    const params = {
      scs: parameters.coordinatorListSelected,
      startDate,
      endDate,
    };
    try {
      const { data: { data } } = await CISO_CMRI_API.get('/contract-usage', { params });
      data.forEach((x) => {
        x.tradeDate = moment(x.tradeDate).utc().format('MM/DD/YY HH:mm');
      });
      commit('setTableData', data);
    } catch {
      this.$notify('Failed to Load Contract Usage', 'error');
    }
  },
};

const mutations = {
  setTableData(state, value) {
    state.tableData = value;
  },
  reset(state) {
    state.tableData = [];
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};